import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Link2, SlidersHorizontal, ChevronRight } from 'lucide-react';

/**
 * AutomationStartDialog — the "what do you want to make?" chooser shown on +.
 * Turns the common cases into a pick-from-a-list and demotes the raw editor to
 * "Advanced".
 */
const OPTIONS = [
  { kind: 'link', icon: Link2, title: 'Link switches', subtitle: 'Make several switches control the same light' },
  { kind: 'advanced', icon: SlidersHorizontal, title: 'Advanced', subtitle: 'Custom “When → Then”' },
];

export default function AutomationStartDialog({ open, onOpenChange, onPick }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent variant="sheet" className="p-6">
        <DialogHeader className="pb-4">
          <DialogTitle>New Automation</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {OPTIONS.map((opt) => {
            const Icon = opt.icon;
            return (
              <button
                key={opt.kind}
                type="button"
                onClick={() => onPick(opt.kind)}
                className="flex w-full items-center gap-4 rounded-2xl border border-border/60 p-4 text-left transition-colors hover:bg-accent/50"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                  <Icon className="h-5 w-5" strokeWidth={2} />
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block font-medium">{opt.title}</span>
                  <span className="block text-sm text-muted-foreground">{opt.subtitle}</span>
                </span>
                <ChevronRight className="h-5 w-5 text-muted-foreground" />
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
